export default __webpack_public_path__ + "static/staff-locker-5c0e0d01b067c57357969654db75c8c5.jpg";